import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type RequestCVDialogueStateType = {
  value: boolean;
};

const initialState = {
  value: false,
} as RequestCVDialogueStateType;

export const requestCVDialogue = createSlice({
  name: "requestCVDialogue",
  initialState,
  reducers: {
    reset: () => initialState,
    open: (state) => {
      state.value = true;
    },
    close: (state) => {
      state.value = false;
    },
  },
});

export const { open, close, reset } = requestCVDialogue.actions;
export default requestCVDialogue.reducer;
